module.exports = __webpack_public_path__ + "static/media/icon-refresh.c4cc5dd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-refresh.svg
// module id = 1247
// module chunks = 19